import { Const } from './const.mod';
// price feed provider
import { PriceFeedProvider, PriceFeedProviderMixins, PriceFeedProviderStore } from './provider/ws-price-feed/price-feed-provider.lib';
// trader transactions provider
// import { TraderTransactionsProvider, TraderTransactionsProviderConst, 
//   TraderTransactionsProviderMixins, TraderTransactionsProviderStore } 
//     from './provider/poll-trader-transactions/trader-transactions-provider.lib'
// main store module contributions  
import { actions } from './store/actions';
import { state } from './store/state';
import { mutations } from './store/mutations';
import { getters } from './store/getters';
// create main store module and merge provider store contributions
const vueProviderStore = {
    state: Object.assign(Object.assign({}, state), PriceFeedProviderStore.state // price feed store state
    ),
    actions: Object.assign(Object.assign({}, actions), PriceFeedProviderStore.actions),
    mutations: Object.assign(Object.assign({}, mutations), PriceFeedProviderStore.mutations),
    getters: Object.assign(Object.assign({}, getters), PriceFeedProviderStore.getters)
};
/**
 * init all providers injectinf vuex store instance
 */
const initProviders = (store) => {
    return [
        new PriceFeedProvider(store),
        // new TraderTransactionsProvider(store)
    ];
};
/**
 *  component mixins
 */
export const ProviderCacheMixins = {
    created() {
        // dynamically extend store with price feed store module
        const _store = this.$store;
        if (!(_store && _store.state && _store.state[Const.STORE_MODULE_NAME])) {
            this.$store.registerModule(Const.STORE_MODULE_NAME, vueProviderStore);
        }
    },
    computed: Object.assign({}, PriceFeedProviderMixins.computed),
    mounted() {
        window.onunload = () => {
            console.log('window on unloading >>>');
            const providers = this.$store.getters[Const.GET_PROVIDERS];
            for (let p in providers) {
                providers[p].stop();
                delete providers[p];
            }
        };
        // emote request to data ware house 
        // therefor why we go over the facade
        const token = this.$store.getters['GET_TOKEN'] || '';
        if (token) {
            this.$store.dispatch(Const.RUN_REGISTER_PROVIDERS, initProviders(this.$store));
        }
    },
    beforeDestroy() {
        console.log('component before destroy >>>');
        const providers = this.$store.getters[Const.GET_PROVIDERS];
        for (let p in providers) {
            providers[p].stop();
            delete providers[p];
        }
    },
    methods: Object.assign({}, PriceFeedProviderMixins.methods)
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/mixin.ts
// module id = null
// module chunks = 